const StatusDepositError: React.FunctionComponent = function () {
  return <div>Error</div>;
};

export default StatusDepositError;
